module.exports = __webpack_public_path__ + "static/img/01-友链2.03f73b3.png";


//////////////////
// WEBPACK FOOTER
// ./public/pc/01-友链2.png
// module id = stVM
// module chunks = 14